"use client";
import { jsx } from "react/jsx-runtime";
import { tokens } from "@gnist/themes/tokens.css.js";
import reactContentLoader from "react-content-loader";
const ContentLoader = reactContentLoader;
function transformDimension(dimension, transform) {
  var _a;
  const numericPart = (_a = /(\d+)(\.\d+)?/.exec(dimension)) == null ? void 0 : _a[0];
  if (!numericPart) {
    return dimension;
  }
  const newNumericPart = transform(parseFloat(numericPart)).toString();
  return dimension.replace(numericPart, newNumericPart);
}
const CircularSkeleton = ({ className, height = "100%", width = "100%" }) => {
  const halfHeight = transformDimension(height, (n) => n / 2);
  const halfWidth = transformDimension(width, (n) => n / 2);
  return jsx(ContentLoader, { height, width, title: "", className, backgroundColor: tokens.color.loader, foregroundColor: tokens.color["on-loader"], children: jsx("ellipse", { cx: halfWidth, cy: halfHeight, rx: halfWidth, ry: halfHeight }) });
};
export {
  CircularSkeleton
};
